export default function getTotal(subtotal, taxTotal, discountTotal, orderDiscountTotal, taxInclusive = false) {
  if (taxInclusive) return subtotal - discountTotal - orderDiscountTotal
  return subtotal + taxTotal - discountTotal  - orderDiscountTotal
}
